/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react';
import { FaChevronDown, FaRegCopy } from 'react-icons/fa6';
import { RiShareLine } from 'react-icons/ri';
import { Link } from 'react-router-dom';
import DateFormatter from 'components/DateFormatter';
import { currencyToLocal, ADD_EDIT_CONSTANT } from 'utils/constants';
import ActionsFormatter from 'components/ActionsFormatter';
import 'pages/Dashboard/components/AllTabsAndTables/dashboard-mobile.css';
import { Pagination, PaginationItem, PaginationLink } from 'reactstrap';
import CouponCountUsers from '../CouponCountUsers';

const CouponMobileView = ({
  data,
  toggleShowDetails,
  toggleSharingDetails,
  handleCopy,
  toggleDeleteRecord,
  handleClickEdit,
  totalCount,
  pageSize,
  currentPageNo,
  handlePageChange,
  hideActions = false,
}) => {
  const [expandedCardId, setExpandedCardId] = useState(null);

  const getPageNumbers = () => {
    const totalPages = Math.ceil(totalCount / pageSize) || 1;
    const pages = [];
    const maxPagesToShow = 5;

    if (totalPages <= maxPagesToShow) {
      for (let i = 1; i <= totalPages; i += 1) {
        pages.push(i);
      }
    } else if (currentPageNo <= 3) {
      for (let i = 1; i <= 4; i += 1) {
        pages.push(i);
      }
      pages.push('...');
      pages.push(totalPages);
    } else if (currentPageNo >= totalPages - 2) {
      pages.push(1);
      pages.push('...');
      for (let i = totalPages - 3; i <= totalPages; i += 1) {
        pages.push(i);
      }
    } else {
      pages.push(1);
      pages.push('...');
      pages.push(currentPageNo - 1);
      pages.push(currentPageNo);
      pages.push(currentPageNo + 1);
      pages.push('...');
      pages.push(totalPages);
    }
    return { pages, totalPages };
  };

  const { pages, totalPages } = getPageNumbers();
  const startIndex = (currentPageNo - 1) * pageSize;

  return (
    <div className="dashboard-mobile-list mt-3">
      {data?.length > 0 ? (
        data.map((item) => {
          const isExpanded = expandedCardId === item.id;

          let discountText = 'N/A';
          if (item.discountValue) {
            const flat =
              item.discountType === 'FLAT'
                ? currencyToLocal(
                    item.discountValue,
                    item.currency?.id === '233' ? 'USD' : 'INR',
                  )
                : '';
            const perc =
              item.discountType === 'PERCENTAGE'
                ? `${item.discountValue}%`
                : '';
            discountText = `${flat}${perc}`;
          }

          return (
            <div className="dashboard-mobile-card" key={item.id}>
              <div className="dashboard-mobile-card__summary">
                <div className="dashboard-mobile-card__identity">
                  <span
                    className="dashboard-mobile-card__name text-blue-c5 cursor-pointer"
                    onClick={() => toggleShowDetails && toggleShowDetails(item)}
                  >
                    {item.code}
                  </span>
                  <div className="dashboard-mobile-card__meta">
                    Discount: {discountText}
                  </div>
                </div>
                <div className="dashboard-mobile-card__aside">
                  <span className="dashboard-mobile-card__pill muted">
                    {item.status}
                  </span>
                  <div className="dashboard-mobile-card__tools">
                    <button
                      type="button"
                      className={`dashboard-mobile-card__expand-toggle ${isExpanded ? 'is-open' : ''}`}
                      onClick={() =>
                        setExpandedCardId((prev) =>
                          prev === item.id ? null : item.id,
                        )
                      }
                    >
                      <FaChevronDown />
                    </button>
                  </div>
                </div>
              </div>

              {isExpanded && (
                <div className="dashboard-mobile-card__body">
                  <div className="dashboard-mobile-card__detail-list">
                    <div className="dashboard-mobile-card__detail-row">
                      <div className="dashboard-mobile-card__detail-label">
                        Usage Limit
                      </div>
                      <div className="dashboard-mobile-card__detail-value">
                        <CouponCountUsers
                          couponId={item.id}
                          usageCount={item.usageCount || 0}
                          count={
                            item.usageLimit
                              ? `${item.usageCount || 0}/${item.usageLimit}`
                              : 'Not Available'
                          }
                        />
                      </div>
                    </div>
                    <div className="dashboard-mobile-card__detail-row">
                      <div className="dashboard-mobile-card__detail-label">
                        Validity Period
                      </div>
                      <div className="dashboard-mobile-card__detail-value">
                        <DateFormatter dateTime={item.fromDate} /> -{' '}
                        <DateFormatter dateTime={item.expiryDate} />
                      </div>
                    </div>
                    <div className="dashboard-mobile-card__detail-row">
                      <div className="dashboard-mobile-card__detail-label">
                        Created Date
                      </div>
                      <div className="dashboard-mobile-card__detail-value">
                        <DateFormatter dateTime={item.createdAt} />
                      </div>
                    </div>

                    {!hideActions && (
                      <div className="dashboard-mobile-card__detail-row pt-2 mt-2 border-top">
                        <div className="d-flex align-items-center justify-content-end w-100 gap-3">
                          {toggleSharingDetails && (
                            <Link
                              className="text-decoration-none"
                              onClick={() => toggleSharingDetails(item)}
                              disabled={item.status === 'INACTIVE'}
                            >
                              <RiShareLine size={18} />
                            </Link>
                          )}
                          {handleCopy && (
                            <Link
                              className="text-decoration-none"
                              onClick={() => handleCopy(item.code)}
                            >
                              <FaRegCopy size={18} />
                            </Link>
                          )}
                          {(toggleDeleteRecord || handleClickEdit) && (
                            <div style={{ transform: 'translateY(-2px)' }}>
                              <ActionsFormatter
                                isView={false}
                                handleDelete={() =>
                                  toggleDeleteRecord &&
                                  toggleDeleteRecord(item.id)
                                }
                                handleEdit={() =>
                                  handleClickEdit &&
                                  handleClickEdit(item, ADD_EDIT_CONSTANT.EDIT)
                                }
                              />
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          );
        })
      ) : (
        <div className="text-center p-3 text-muted">No Data Found</div>
      )}

      {totalPages > 1 && (
        <div className="d-flex justify-content-between align-items-center mt-3 flex-wrap gap-3">
          <div className="f-13 text-muted">
            Showing <strong>{startIndex + 1}</strong> to{' '}
            <strong>{Math.min(startIndex + pageSize, totalCount)}</strong> of{' '}
            <strong>{totalCount}</strong> entries
          </div>
          <Pagination className="mb-0 pagination-custom dashboard-mobile-pagination">
            <PaginationItem disabled={currentPageNo === 1}>
              <PaginationLink
                previous
                onClick={() =>
                  handlePageChange({ pageNo: currentPageNo - 1, pageSize })
                }
              >
                ‹
              </PaginationLink>
            </PaginationItem>
            {pages.map((page, idx) => (
              <PaginationItem
                key={
                  typeof page === 'number' ? `page-${page}` : `ellipsis-${idx}`
                }
                active={page === currentPageNo}
                disabled={page === '...'}
              >
                <PaginationLink
                  onClick={() =>
                    typeof page === 'number' &&
                    handlePageChange({ pageNo: page, pageSize })
                  }
                >
                  {page}
                </PaginationLink>
              </PaginationItem>
            ))}
            <PaginationItem disabled={currentPageNo === totalPages}>
              <PaginationLink
                next
                onClick={() =>
                  handlePageChange({ pageNo: currentPageNo + 1, pageSize })
                }
              >
                ›
              </PaginationLink>
            </PaginationItem>
          </Pagination>
        </div>
      )}
    </div>
  );
};

export default CouponMobileView;
